import React from 'react'
import './Subscribe.css';

function Subscribe() {
    return (
        <section className="newsletter">
            <h3>subscribe for latest updates</h3>
            <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Voluptatum, suscipit.</p>
            <form action="">
                    <input type="email" placeholder="enter your email" />
                    <input type="submit" value="subscribe" />
            </form>
        </section>
    )
}

export default Subscribe
